import { IPermission } from '../dtos/responses/permission.response';
import { TreeNode } from 'primeng/api';
import { ITypedLookup } from '../../common/models/permission-marker-lookup';

export class Permission implements IPermission {
    static PermissionType = 'Permission';
    type: string = Permission.PermissionType;
    id: string;
    englishName: string;

    private constructor(permission: IPermission) {
        this.id = permission.id;
        this.englishName = permission.englishName;
    }

    public static create(permission: IPermission): Permission {
        return new Permission(permission);
    }

    public static createAsPermissions(permissions: IPermission[]): Permission[] {
        return permissions.map(this.create);
    }

    public static createAsTreeNode(permission: IPermission): TreeNode<ITypedLookup<string>> {
        return Permission.create(permission).toTreeNode();
    }

    public static createAsTreeNodes(permissions: IPermission[]): TreeNode<ITypedLookup<string>>[] {
        return permissions.map(this.createAsTreeNode);
    }

    toTreeNode(): TreeNode<ITypedLookup<string>> {
        return {
            key: this.id,
            label: this.getReadableName(),
            data: this,
            leaf: true,
            selectable: true,
            icon: 'pi pi-key'
        };
    }

    public getReadableName() {
        return this.englishName.getLastPart('.');
    }
}
